( function ($) {
    $(document).ready(function () {
        acGallery();
    });
    function fixFancyboxSlick(innerElem) {
        // Fix for mini gallery fancy box
        var selector = '.slick-slide:not(.slick-cloned)';
        if(innerElem){
            selector = selector+' '+innerElem;
        }
        // Skip cloned elements
        $().fancybox({
            selector: selector,
            backFocus: false,
            loop: true

        });
        // Remove fancybox cloned elements
        if(innerElem){
            $('.slick-cloned '+innerElem).each( function () {
                $(this).removeAttr('data-fancybox');
            });

        }else {
            $('.slick-cloned .thumb').removeAttr('data-fancybox');
        }


        // Attach custom click event on cloned elements,
        // trigger click event on corresponding link
        var clonedElement = '.slick-cloned';
        if(innerElem){
            clonedElement = '.slick-cloned '+innerElem;
        }
        $(document).on('click', clonedElement, function (e) {
            $(selector)
                .eq(( $(e.currentTarget).attr("data-slick-index") || 0) % $(selector).length)
                .trigger("click.fb-start", {
                    $trigger: $(this)
                });

            return false;
        });
    }
    function acGallery() {
        var wraps = $('.de_block_additional_content .slider');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                if (wrap.find('.thumb_wrap').length > 1) {
                    wrap.slick({
                        rtl: $('html').attr('dir') === 'rtl',
                        arrows: true,
                        dots: true,
                        infinite: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        appendDots: wrap.parent().find('.pager'),
                    });
                    fixFancyboxSlick('.thumb');
                }
            });
        }
    }

}(jQuery) );